import React from 'react';
import './RSVP.css';
const Rsvp = () => {
  return (
    <div className="rsvp-page">
      <h1>Respondez s'il vous plait!</h1>
      <div className="rsvp-message">
      <h3>
        Please RSVP by March 17th, 2025. <br></br><br></br>If we do not see a response by this date, we will assume you are unable to join us and will mark you down as a "No"! <br/> <br/>  Use the link below to RSVP!
      </h3>
      <button className="rsvp-btn"
        onClick={() => window.open('https://www.zola.com/wedding/mollyandcameronmay17', '_blank')}>
        RSVP Now
      </button>
      </div>

    </div>
  );
};

export default Rsvp;




